import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { WMS1141_R01DetailDto } from "../Dto_WMS1141_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { isSubcontractMaterialInoutClass, normalizeWMS1141DetailRow } from "../Constants_WMS1141_R01";
interface UseWMS1141_R01CellChangeProps {
	WMS1141_R01DetailList: WMS1141_R01DetailDto[];
	originalWMS1141_R01DetailList: WMS1141_R01DetailDto[];
	updateWMS1141_R01DetailList: (index: number, data: WMS1141_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<WMS1141_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
	customCd?: string;
	inoutClass?: string;
}

export function useWMS1141_R01CellChange({
	WMS1141_R01DetailList,
	originalWMS1141_R01DetailList,
	updateWMS1141_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
	customCd,
	inoutClass,
}: UseWMS1141_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const WMS1141R01Config = createModuleConfig.WMS1141();
	const isSubcontractInout = isSubcontractMaterialInoutClass(inoutClass);

		 // PROGRAM 공통코드에서 ITEM_POPUP_SEARCH의 ref01 값으로 필터 사용 여부 결정
		 const { programList } = useCommonCodeStore();
		 const useCustomCdFilter =
			 programList.find(c => c.minorCd === 'ITEM_POPUP_SEARCH')?.ref01 === 'Y';

	const itemCdBaseConfig = WMS1141R01Config.fieldConfig.codeSearchFields!.itemCd;
	const { itemCost: _itemCost, ...responseMappingWithoutCost } = itemCdBaseConfig.responseMapping;

	const fieldConfigWithSearch = {
		...WMS1141R01Config.fieldConfig,
		codeSearchFields: {
			...WMS1141R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...itemCdBaseConfig,
				responseMapping: isSubcontractInout
					? responseMappingWithoutCost
					: itemCdBaseConfig.responseMapping,
				searchFilters: () =>
					useCustomCdFilter && customCd?.trim() ? { customCd: customCd.trim() } : undefined,
				searchFunction: searchExactItemCode,
				canOpenModal: (row: WMS1141_R01DetailDto) => !!row?.inserted,
			},
		},
	};

	const calculateAmount = (data: WMS1141_R01DetailDto): WMS1141_R01DetailDto => {
		return normalizeWMS1141DetailRow(data, inoutClass);
	};

	return useCommonDetailTableHandlers<WMS1141_R01DetailDto>({
		detailList: WMS1141_R01DetailList,
		updateDetailList: updateWMS1141_R01DetailList,
		originalDetailList: originalWMS1141_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: WMS1141R01Config.codeSearchConfig,
		calculateAmount,
	});
}
